// ═══════════════════════════════════════════════════════════════════
//  layout/navigation.js
//  Entrées de navigation et filtrage par rôle.
// ═══════════════════════════════════════════════════════════════════

// Labels courts pour la barre d'onglets mobile
export const MOBILE_SHORT = {
  dashboard: "Accueil", console: "Console", tickets: "Tickets",
  erp: "ERP", kanban: "Projet", docs: "Docs", wiki: "Wiki", chat: "Chat", courriel: "Mail",
  sanctions: "Sanctions",
  luckperms: "LuckPerms",
  hub: "Hub",
  catalogue: "Barème",
  shop: "Magasin",
  classements: "Tops",
  ah: "AH",
};

// Filtrage par rôle : Documents et Hub réservés aux super_admins.
// Le backend refuse de toute façon — l'interface cache, elle ne protège pas.
const RESERVES_FONDATEUR = ["docs", "hub"];
export function navItemsForRole(role) {
  return NAV_ITEMS.filter((it) => !RESERVES_FONDATEUR.includes(it.id) || role === "super_admin");
}

// 4 modules de la barre d'onglets selon le rôle (CDC §6 / Q2)
export function mobilePrimaryIds(role) {
  return role === "super_admin"
    ? ["dashboard", "docs", "kanban", "tickets"]
    : ["dashboard", "console", "tickets", "erp"];
}

// ─── NAVIGATION ───
export const NAV_ITEMS = [
  { id: "dashboard", icon: "🏠", label: "Dashboard", ready: true },
  { id: "console", icon: "🖥️", label: "Console", ready: true },
  { id: "tickets", icon: "🎫", label: "Tickets", ready: true },
  { id: "erp", icon: "👤", label: "Joueurs (ERP)", ready: true },
  { id: "ah", icon: "🏪", label: "Hôtel des ventes", ready: true },
  { id: "classements", icon: "🏆", label: "Classements", ready: true },
  { id: "catalogue", icon: "⚖️", label: "Barème et récompenses", ready: true },
  { id: "shop", icon: "🛒", label: "Magasin", ready: true },
  { id: "kanban", icon: "📋", label: "Gestion projet", ready: true },
  { id: "chat", icon: "💬", label: "Chat en jeu", ready: true },
  { id: "courriel", icon: "📧", label: "Courriel", ready: true },
  { id: "wiki", icon: "📚", label: "Wiki Staff", ready: true },
  { id: "sanctions", icon: "⚖️", label: "Suivi des Sanctions", ready: true },
  { id: "docs", icon: "📁", label: "Documents", ready: true },
  { id: "luckperms", icon: "🔑", label: "LuckPerms", ready: true },
  { id: "hub", icon: "🌐", label: "Hub", ready: true },
];
